var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from 'antd';
import { QrIcon } from "../../../helpers/icons";
import styles from './QrCodeButton.module.scss';
export var QrCodeButton = function (_a) {
    var onQrShow = _a.onQrShow;
    return (_jsx(Button, __assign({ icon: _jsx(QrIcon, {}), className: styles.qrButton, onClick: function () { return onQrShow(true); } }, { children: "Sign in with QR code" })));
};
